export const EXTERNAL_COMMUNICATION_EVENTS = {
    // Instrument height
    GET_INSTRUMENT_HEIGHT_REQUEST: 'GET INSTRUMENT_HEIGHT REQUEST',
    GET_INSTRUMENT_HEIGHT_PROCESS: 'GET INSTRUMENT_HEIGHT PROCESS', // can be used with _STARTED & _FINISHED
    GET_INSTRUMENT_HEIGHT_RESPONSE: 'GET INSTRUMENT_HEIGHT RESPONSE',

    GET_STATION_POSITION_REQUEST: 'GET STATION_POSITION REQUEST',
    GET_STATION_POSITION_RESPONSE: 'GET STATION_POSITION RESPONSE',

    // User preferences workflow
    GET_USER_PREFERENCES_REQUEST: 'GET USER_PREFERENCES REQUEST',
    GET_USER_PREFERENCES_RESPONSE: 'GET USER_PREFERENCES RESPONSE',
    SET_USER_PREFERENCES_REQUEST: 'SET USER_PREFERENCES REQUEST',
    SET_USER_PREFERENCES_RESPONSE: 'SET USER_PREFERENCES RESPONSE',

    SET_WORKFLOW_STATE_RESPONSE: 'SET WORKFLOW_STATE RESPONSE',

    SET_TOPBAR_STATE_REQUEST: 'SET TOPBAR_STATE REQUEST',
    SET_TOPBAR_STATE_RESPONSE: 'SET TOPBAR_STATE RESPONSE',

    ACTION_GET_FILE_CONTENTS_REQUEST: 'ACTION GET_FILE_CONTENTS REQUEST',
    ACTION_GET_FILE_CONTENTS_RESPONSE: 'ACTION GET_FILE_CONTENTS RESPONSE',
    ACTION_COPY_AND_COMPRESS_FILES_REQUEST: 'ACTION COPY_AND_COMPRESS_FILES REQUEST',
    ACTION_COPY_AND_COMPRESS_FILES_RESPONSE: 'ACTION COPY_AND_COMPRESS_FILES RESPONSE',

    SET_SCANNER_STATE_RESPONSE: 'SET SCANNER_STATE RESPONSE',
    GET_SCANNER_STATE_REQUEST: 'GET SCANNER_STATE REQUEST',
    GET_SCANNER_STATE_RESPONSE: 'GET SCANNER_STATE RESPONSE',

    CREATE_NEW_STATION_REQUEST: 'CREATE NEW_STATION REQUEST',
    CREATE_NEW_STATION_PROCESS: 'CREATE NEW_STATION PROCESS', // can be used with _STARTED & _FINISHED
    CREATE_NEW_STATION_RESPONSE: 'CREATE NEW_STATION RESPONSE',

    GET_LAYOUT_POINT_REQUEST: 'GET LAYOUT_POINT REQUEST',

    GET_STANDARD_VERIFICATION_REQUEST: 'GET STANDARD_VERIFICATION REQUEST',
    GET_STANDARD_VERIFICATION_PROCESS_STARTED: 'GET STANDARD_VERIFICATION PROCESS_STARTED',
    GET_STANDARD_VERIFICATION_PROCESS_PROGRESS: 'GET STANDARD_VERIFICATION PROCESS_PROGRESS',
    GET_STANDARD_VERIFICATION_PROCESS_FINISHED: 'GET STANDARD_VERIFICATION PROCESS_FINISHED',
    GET_STANDARD_VERIFICATION_RESPONSE: 'GET STANDARD_VERIFICATION RESPONSE',

    GET_TOTALSTATION_VERIFICATION_REQUEST: 'GET TOTALSTATION_VERIFICATION REQUEST',
    GET_TOTALSTATION_VERIFICATION_PROCESS_STARTED: 'GET TOTALSTATION_VERIFICATION PROCESS_STARTED',
    GET_TOTALSTATION_VERIFICATION_PROCESS_PROGRESS: 'GET TOTALSTATION_VERIFICATION PROCESS_PROGRESS',
    GET_TOTALSTATION_VERIFICATION_PROCESS_FINISHED: 'GET TOTALSTATION_VERIFICATION PROCESS_FINISHED',
    GET_TOTALSTATION_VERIFICATION_RESPONSE: 'GET TOTALSTATION_VERIFICATION RESPONSE',

    GET_REPORT_PICK_POINT_REQUEST: 'GET REPORT_PICK_POINT REQUEST',
    GET_REPORT_PICK_POINT_RESPONSE: 'GET REPORT_PICK_POINT RESPONSE',
    SET_PICKED_POINT_RESPONSE: 'SET PICKED_POINT RESPONSE',

    GET_PROJECT_DATA_REQUEST: 'GET PROJECT_DATA REQUEST',
    GET_PROJECT_DATA_RESPONSE: 'GET PROJECT_DATA RESPONSE',

    GET_SCAN_TARGET_REQUEST: 'GET SCAN_TARGET REQUEST',
    GET_SCAN_TARGET_PROCESS: 'GET SCAN_TARGET PROCESS', // can be used with _STARTED, _PROGRESS & _FINISHED
    GET_SCAN_TARGET_RESPONSE: 'GET SCAN_TARGET RESPONSE',

    GET_TRANSFER_STATION_DATA_REQUEST: 'GET TRANSFER_STATION_DATA REQUEST',
    GET_TRANSFER_STATION_DATA_RESPONSE: 'GET TRANSFER_STATION_DATA RESPONSE',
    GET_TRANSFER_STATION_DATA_QUEUED_RESPONSE: 'GET TRANSFER_STATION_DATA_QUEUED RESPONSE',

    SET_CURRENT_STATION_RESPONSE: 'SET CURRENT_STATION RESPONSE',

    GET_SCAN_CLOUD_REQUEST: 'GET SCAN_CLOUD REQUEST',
    GET_SCAN_CLOUD_PROCESS: 'GET SCAN_CLOUD PROCESS', // can be used with _STARTED, _PROGRESS & _FINISHED
    GET_SCAN_CLOUD_RESPONSE: 'GET SCAN_CLOUD RESPONSE',

    GET_WINDOW_SCAN_CLOUD_REQUEST: 'GET WINDOW_SCAN_CLOUD REQUEST',
    GET_WINDOW_SCAN_CLOUD_PROCESS: 'GET WINDOW_SCAN_CLOUD PROCESS', // can be used with _STARTED, _PROGRESS & _FINISHED
    GET_WINDOW_SCAN_CLOUD_RESPONSE: 'GET WINDOW_SCAN_CLOUD RESPONSE',

    GET_SCAN_CLOUD_AND_RESECTION_REQUEST: 'GET SCAN_CLOUD_AND_RESECTION REQUEST',
    GET_SCAN_CLOUD_AND_RESECTION_PROCESS: 'GET SCAN_CLOUD_AND_RESECTION PROCESS', // can be used with _STARTED, _PROGRESS & _FINISHED
    GET_SCAN_CLOUD_AND_RESECTION_RESPONSE: 'GET SCAN_CLOUD_AND_RESECTION RESPONSE',

    GET_MULTI_SCAN_CLOUD_REQUEST: 'GET MULTI_SCAN_CLOUD REQUEST',
    GET_MULTI_SCAN_CLOUD_PROCESS: 'GET MULTI_SCAN_CLOUD PROCESS', // can be used with _STARTED, _PROGRESS & _FINISHED
    GET_MULTI_SCAN_CLOUD_PROCESS_PROGRESS: 'GET MULTI_SCAN_CLOUD PROCESS_PROGRESS',
    GET_MULTI_SCAN_CLOUD_RESPONSE: 'GET MULTI_SCAN_CLOUD RESPONSE',

    SET_RESECTION_PAIRS_RESPONSE: 'SET RESECTION_PAIRS RESPONSE',

    SET_AUTO_TARGET_PREVIEW_RESPONSE: 'SET AUTO_TARGET_PREVIEW RESPONSE',

    SET_RIGHT_COLUMN_SIZE_RESPONSE: 'SET RIGHT_COLUMN_SIZE RESPONSE',

    // Stations transformations (for Verity integration in Collage Site)
    GET_STATIONS_TRANSFORMATIONS_REQUEST: 'GET STATIONS_TRANSFORMATIONS REQUEST',
    GET_STATIONS_TRANSFORMATIONS_RESPONSE: 'GET STATIONS_TRANSFORMATIONS RESPONSE',

    SET_LAYOUT_NAVIGATION_VIEW_RESPONSE: 'SET LAYOUT_NAVIGATION_VIEW RESPONSE',
    SET_PRISM_POLE_POSITION_RESPONSE: 'SET PRISM_POLE_POSITION RESPONSE',

    GET_POINT_MEASUREMENT_PROCESS: 'GET POINT_MEASUREMENT PROCESS', // We don't show progress in UI
    GET_POINT_MEASUREMENT_RESPONSE: 'GET POINT_MEASUREMENT RESPONSE',

    GET_RCP_EXPORT_REQUEST: 'GET RCP_EXPORT REQUEST',
    GET_RCP_EXPORT_RESPONSE: 'GET RCP_EXPORT RESPONSE',

    IFRAME_MESSAGE: 'message',
};

Object.freeze(EXTERNAL_COMMUNICATION_EVENTS);
